export class LoadingIndicator {
    constructor() {
        // 创建遮罩层
        this.overlay = document.createElement('div');
        this.overlay.style.position = 'fixed';
        this.overlay.style.top = '0';
        this.overlay.style.left = '0';
        this.overlay.style.width = '100%';
        this.overlay.style.height = '100%';
        this.overlay.style.backgroundColor = 'transparent';
        this.overlay.style.zIndex = '9998';
        this.overlay.style.cursor = 'not-allowed';

        // 添加点击事件监听器
        this.overlay.addEventListener('click', () => {
            if (this.currentProgress < 100) {
                alert('请等待游戏资源加载完成');
            }
        });

        document.body.appendChild(this.overlay);
        
        // 添加当前进度记录
        this.currentProgress = 0;

        this.element = document.createElement('div');
        this.element.className = 'loading-indicator';
        this.element.style.position = 'fixed';
        this.element.style.top = '50%';
        this.element.style.left = '50%';
        this.element.style.transform = 'translate(-50%, -50%)';
        this.element.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
        this.element.style.padding = '20px 40px';
        this.element.style.borderRadius = '15px';
        this.element.style.color = '#fff';
        this.element.style.fontFamily = 'Arial, sans-serif';
        this.element.style.textAlign = 'center';
        this.element.style.zIndex = '9999';
        this.element.style.transition = 'opacity 0.5s';

        // 创建进度条容器
        this.progressContainer = document.createElement('div');
        this.progressContainer.style.width = '300px';
        this.progressContainer.style.height = '10px';
        this.progressContainer.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
        this.progressContainer.style.borderRadius = '5px';
        this.progressContainer.style.margin = '10px 0';

        // 创建进度条
        this.progressBar = document.createElement('div');
        this.progressBar.style.width = '0%';
        this.progressBar.style.height = '100%';
        this.progressBar.style.backgroundColor = '#4CAF50';
        this.progressBar.style.borderRadius = '5px';
        this.progressBar.style.transition = 'width 0.3s';

        // 创建状态文本
        this.statusText = document.createElement('div');
        this.statusText.style.marginBottom = '10px';
        this.statusText.style.fontSize = '18px';

        // 创建百分比文本
        this.percentText = document.createElement('div');
        this.percentText.style.fontSize = '24px';
        this.percentText.style.fontWeight = 'bold';

        // 组装元素
        this.progressContainer.appendChild(this.progressBar);
        this.element.appendChild(this.statusText);
        this.element.appendChild(this.progressContainer);
        this.element.appendChild(this.percentText);

        document.body.appendChild(this.element);
    }

    updateProgress(percent, status) {
        this.currentProgress = percent;
        this.progressBar.style.width = `${percent}%`;
        this.percentText.textContent = `${Math.round(percent)}%`;
        this.statusText.textContent = status;

        // 当进度达到100%时移除遮罩层
        if (percent >= 100) {
            this.overlay.style.display = 'none';
        } else {
            // 确保在加载未完成时遮罩层始终显示
            this.overlay.style.display = 'block';
        }
    }

    show() {
        this.element.style.display = 'block';
        this.element.style.opacity = '1';
        this.overlay.style.display = 'block';
    }

    hide() {
        this.element.style.opacity = '0';
        this.overlay.style.display = 'none';
        setTimeout(() => {
            this.element.style.display = 'none';
        }, 500);
    }
}